import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()

const COLABORADORES="talent_cloud/colaboradores"
const COLABORADOR_RH=`${COLABORADORES}/rh`
const COLABORADORES_MY_TEAM=`${COLABORADORES}/my_team`


export const colaboradoresGet = (params) => {
	const controller= loadAbort()
	const call= axios.get(COLABORADORES,{params,signal:controller.signal})
	return {call,controller}
}
export const colaboradoresMyTeamGet = (params) => {
	const controller= loadAbort()
	const call= axios.get(COLABORADORES_MY_TEAM,{params,signal:controller.signal})
	return {call,controller}
}


export const colaboradorRhGet = (params) => {
	const controller= loadAbort()
	const call= axios.get(COLABORADOR_RH,{params,signal:controller.signal})
	return {call,controller}
}
export const colaboradorIdGet = ({id,params}) => {
	const controller= loadAbort()
	const call= axios.get(`colaboradores/${id}`,{params,signal:controller.signal})
	return {call,controller}
}